import "react-datepicker/dist/react-datepicker.css";

import { Field } from "@sitecore-jss/sitecore-jss-react";
import nl from "date-fns/locale/nl";
import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";

import { ModelState } from "../../interfaces/modelState";
import dateUtil from "../../lib/dateUtil";
import { Tooltip } from "../tooltip/Tooltip";
import { hasValidationMessage } from "../validationMessage/hasValidationMessage";
import { ValidationMessage } from "../validationMessage/ValidationMessage";
import useFieldData from "./useFieldData";
import useFieldName from "./useFieldName";

interface Props {
  fieldData: Record<string, Field<string>>;
  name: string;
  fieldName?: string;
  modelState?: ModelState | null;
  setModelState?: (modelState: ModelState) => void;
  inputValue?: string;
  id?: string;
  onChange?: (value?: string) => void;
  propertyName: string;
  required?: boolean;
  disabled?: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
}

const DateInput = (props: Props) => {
  registerLocale("nl", nl);
  const dateFormat = "dd-MM-yyyy";
  const { name, fieldName } = useFieldName(props.name, props.fieldName);
  const { heading, placeholder, info, tooltip } = useFieldData(props.fieldData, name);
  const formattedDate = props.inputValue ? dateUtil.dutchDateToMoment(props.inputValue).toDate() : null;

  const onFieldChange = (d: Date | null) => {
    if (props.onChange) {
      if (d) {
        props.onChange(dateUtil.formatDutchDate(d));
      } else {
        props.onChange(undefined);
      }
    }
  };

  const id = props.id || fieldName;
  const hasError = hasValidationMessage(props.modelState, props.propertyName);

  return (
    <div className="form-row form-row-date">
      <div className="form-item date">
        <div className="form-label">
          <label htmlFor={id}>{heading.value}</label>
          <Tooltip disabled={props.disabled} fieldName={fieldName} value={tooltip.value} />
        </div>
        <div className="form-input">
          <div className="date-input">
            <DatePicker
              disabled={props.disabled}
              required={props.required}
              locale="nl"
              name={fieldName}
              id={id}
              autoComplete="off"
              selected={formattedDate}
              dateFormat={dateFormat}
              minDate={props.minDate}
              maxDate={props.maxDate}
              placeholderText={placeholder.value}
              onChange={onFieldChange}
              popperPlacement="top-start"
              popperModifiers={[
                {
                  name: "arrow",
                },
              ]}
              ariaInvalid={`${hasError}`}
            />
          </div>
        </div>
        {info && <span>{info.value}</span>}
      </div>
      <ValidationMessage modelState={props.modelState} property={props.propertyName} />
    </div>
  );
};

export default DateInput;
